import React, { useRef, useState } from "react";

import entranteaguacatesalmonImg from "../../images/entrante_vasito-aguacate-salmon-ahumado.png";
import primerplatotortillaImg from "../../images/primer-plato_tortilla-patata-adaptada.png";
import segundoplatolentejasImg from "../../images/segundo-plato_lentejas-posaderas.png";
import postrearrozlecheImg from "../../images/postre_arroz-con-leche.png";

function SlideCard({ bg = "bg-[#f4f8fc]", children }) {
  return (
    <div className={`${bg} h-full p-6 rounded-lg shadow overflow-y-auto`}>
      {children}
    </div>
  );
}

export default function MenuTexturaPudin() {
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(null);
  const touchDeltaX = useRef(0);

  // Slides
  const slides = [
    {
      key: "entrante-aguacate-salmon",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>ENTRANTE: VASITO DE AGUACATE CON SALMÓN AHUMADO</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={entranteaguacatesalmonImg}
                alt="ENTRANTE: VASITO DE AGUACATE CON SALMÓN AHUMADO"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para dos personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- Medio aguacate maduro.</li>
              <li>- 1 cucharada de queso de cabra.</li>
              <li>- 2 lonchas de salmón ahumado (40 g aprox).</li>
              <li>- Sal al gusto.</li>
              <li>- Limón al gusto.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Colocar en un bol el aguacate en trozos pequeños, el queso batido y el salmón ahumado en trozos pequeños y triturar con una batidora.</li>
              <li>Añadir la sal y un chorrito de limón y mezclar.</li>
              <li>Servir la mezcla en vasitos individuales.</li>
            </ol>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Nota:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Si se necesita una textura más espesa puede añadir una rebanada de pan.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "primer-plato-tortilla",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>PRIMER PLATO: TORTILLA DE PATATAS ADAPTADA</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={primerplatotortillaImg}
                alt="PRIMER PLATO: TORTILLA DE PATATAS ADAPTADA"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para dos personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 300 g de patatas.</li>
              <li>- 1 cebolla pequeña.</li>
              <li>- Aceite de oliva virgen.</li>
              <li>- Sal.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Lavar y cortar la cebolla en láminas, freír durante unos minutos y reservar.</li>
              <li>Pelar y lavar las patatas.</li>
              <li>Cortar las patatas en láminas finas y freír con aceite de oliva.</li>
              <li>Batir los huevos añadiéndole sal al gusto.</li>
              <li>Añadir los huevos junto con las patatas y la cebolla y cocinar hasta que la mezcla cuaje.</li>
              <li>Cortar la porción deseada y triturarla con una batidora hasta conseguir una mezcla homogénea.</li>
            </ol>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Nota:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Servir la tortilla adaptada intentando conseguir la imagen clásica de la tortilla de patatas (pincho de tortilla).</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "segundo-plato-lentejas",
      content: (
        <SlideCard bg="bg-[#f4f8fc]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>SEGUNDO PLATO: LENTEJAS POSADERAS</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={segundoplatolentejasImg}
                alt="SEGUNDO PLATO: LENTEJAS POSADERAS"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para cuatro personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 400 g de lentejas.</li>
              <li>- 1 pimiento verde.</li>
              <li>- 1 cebolla.</li>
              <li>- 2 yemas de huevo.</li>
              <li>- 1 chorrito de vinagre.</li>
              <li>- Perejil.</li>
              <li>- Aceite de oliva.</li>
              <li>- Agua.</li>
              <li>- Sal.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Cocer las lentejas con un chorrito de aceite, sal y el pimiento verde durante una hora aproximadamente.</li>
              <li>En una sartén rehogar la cebolla picada.</li>
              <li>Añadir el sofrito en la olla con las lentejas cocidas y un poco de perejil picado y dejara cocer 5 minutos más.</li>
              <li>Batir las yemas de huevo con una cucharada grande de vinagre y añadir a la olla.</li>
              <li>Mezclar bien y dejar reposar unos 2-3 minutos.</li>
              <li>Triturar las lentejas hasta conseguir una mezcla homogénea y emplatar.</li>
            </ol>
          </div>
        </SlideCard>
      ),
    },
    {
      key: "postre-arroz-leche",
      content: (
        <SlideCard bg="bg-[#dfeaf7]">
          <div className="text-justify space-y-4 pl-10 pr-10 pb-2">
            <h6 className="text-center font-semibold mb-6">
              <u>POSTRE: ARROZ CON LECHE</u>
            </h6>

            <div className="flex justify-center mb-6">
              <img
                src={postrearrozlecheImg}
                alt="POSTRE: ARROZ CON LECHE"
                className="rounded-2xl shadow-lg w-full max-w-[250px] object-cover"
              />
            </div>

            <p className="text-justify font-semibold mb-4">Ingredientes para cuatro personas:</p>
            <ul className="text-justify list-none space-y-2">
              <li>- 800 ml de leche entera.</li>
              <li>- 40 g de azúcar.</li>
              <li>- 40 g de arroz.</li>
              <li>- 1 rama de canela.</li>
              <li>- 5 g de mantequilla.</li>
            </ul>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Modo de preparación:</p>
            <ol className="text-justify list-decimal list-inside space-y-2">
              <li>Calentar la leche con la rama de canela y el azúcar. Cuando empiece a hervir añadir el arroz y remover continuamente para que no se pegue.</li>
              <li>Cocer hasta que el arroz esté blando y posteriormente, dejar enfriar.</li>
              <li>Una vez frío añadir la mantequilla y triturar con una batidora.</li>
              <li>Tamizar la mezcla para conseguir una textura lisa y sin grumos.</li>
              <li>Colocar la mezcla en raciones individuales y añadir canela al gusto.</li>
            </ol>

            <hr className="border-gray-300" />

            <p className="text-justify font-semibold mb-4">Nota:</p>
            <ul className="text-justify list-none space-y-2">
              <li>Si necesitamos una textura menos espesa podemos añadir una cucharada sopera de leche y mezclar.</li>
            </ul>
          </div>
        </SlideCard>
      ),
    },
  ];

  const prev = () => setIndex((i) => Math.max(0, i - 1));
  const next = () => setIndex((i) => Math.min(slides.length - 1, i + 1));

  // Gestos táctiles
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchDeltaX.current = 0;
  };
  const onTouchMove = (e) => {
    if (touchStartX.current == null) return;
    const currentX = e.touches[0].clientX;
    touchDeltaX.current = currentX - touchStartX.current;
  };
  const onTouchEnd = () => {
    const threshold = 50;
    if (touchDeltaX.current < -threshold) next();
    if (touchDeltaX.current > threshold) prev();
    touchStartX.current = null;
    touchDeltaX.current = 0;
  };

  // Teclado
  const onKeyDown = (e) => {
    if (e.key === "ArrowRight") next();
    if (e.key === "ArrowLeft") prev();
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h5 className="font-bold text-center">Menú textura pudin (sin espesante)</h5>
      </div>

      {/* Carrusel con altura fija */}
      <div
        className="relative overflow-hidden rounded-lg h-[520px] sm:h-[580px]"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onKeyDown={onKeyDown}
        tabIndex={0}
        aria-roledescription="carousel"
        aria-label="Recetas de disfagia"
      >
        <div
          className="flex h-full transition-transform duration-300 ease-out"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide) => (
            <div key={slide.key} className="min-w-full h-full px-0">
              {slide.content}
            </div>
          ))}
        </div>

        {/* Flechas */}
        <button
          type="button"
          onClick={prev}
          disabled={index === 0}
          aria-label="Anterior"
          className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 backdrop-blur px-3 py-2 shadow hover:bg-white disabled:opacity-40"
        >
          ←
        </button>
        <button
          type="button"
          onClick={next}
          disabled={index === slides.length - 1}
          aria-label="Siguiente"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/80 backdrop-blur px-3 py-2 shadow hover:bg-white disabled:opacity-40"
        >
          →
        </button>

        {/* Indicadores */}
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2">
          {slides.map((_, i) => (
            <span
              key={i}
              className={`h-2 w-2 rounded-full ${i === index ? "bg-gray-800" : "bg-gray-400"}`}
              aria-label={`Ir al slide ${i + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Texto + descargable */}
      <div className="flex items-center">
        <p className="text-justify gap-4 mt-2 mb-4">
          Si desea obtener el descargable, pulse en el siguiente{" "}
          <a
            href="/docs/menus-adaptados-disfagia_menu-textura-pudin.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            enlace
          </a>
          .
        </p>
      </div>

    </div>
  );
}